import React, { useEffect } from 'react';

function Confidentialitate() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const primaryOrange = "#ff8e18";
    const trustNavy = "#1c2e4a";

    return (
        <div className="bg-light min-vh-100 pb-5">
            <div className="text-center text-white" style={{ background: `linear-gradient(135deg, ${trustNavy} 0%, #000 100%)`, paddingTop: '120px', paddingBottom: '3rem' }}>
                <div className="container">
                    <h1 className="fw-bold display-5">Politica de Confidentialitate</h1>
                    <div style={{ width: '60px', height: '4px', background: primaryOrange, margin: '20px auto', borderRadius: '2px' }}></div>
                    <p className="opacity-75">Conform Regulamentului UE 2016/679 (GDPR)</p>
                </div>
            </div>

            <div className="container mt-n5">
                <div className="card shadow-lg border-0 rounded-3 p-4 p-md-5" style={{ marginTop: '-40px' }}>
                    <div className="card-body text-secondary" style={{ fontSize: '1rem', lineHeight: '1.75' }}>

                        <p className="lead">
                            Confidentialitatea datelor dumneavoastra este importanta pentru noi.
                            Aceasta politica explica ce date colectam si cum le folosim.
                        </p>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">1. Ce date colectam?</h4>
                        <p>Nu colectam date personale sensibile prin simpla vizitare a site-ului. Putem colecta:</p>
                        <ul>
                            <li><strong>Date tehnice:</strong> Adresa IP, tipul browserului (prin log-uri de server standard pentru securitate).</li>
                            <li><strong>Date de contact:</strong> Daca ne contactati telefonic sau prin email, vom folosi acele date doar pentru a va raspunde.</li>
                        </ul>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">2. Scopul Colectarii</h4>
                        <p>
                            Datele sunt utilizate strict pentru:
                        </p>
                        <ul>
                            <li>Asigurarea functionarii corecte a site-ului.</li>
                            <li>Statistici anonime de trafic (prin Google Analytics, daca este activat).</li>
                            <li>Comunicarea cu clientii interesati de masini.</li>
                        </ul>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">3. Cookie-uri</h4>
                        <p>
                            Acest site poate folosi cookie-uri pentru a imbunatati experienta de navigare (ex: tinerea minte a filtrelor selectate).
                            Puteti dezactiva cookie-urile din setarile browserului dumneavoastra.
                        </p>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">4. Partajarea Datelor</h4>
                        <p>
                            <strong>Nu vindem</strong> si nu instrainam datele dumneavoastra personale catre terti in scopuri de marketing.
                            Datele pot fi transmise autoritatilor doar daca exista o obligatie legala.
                        </p>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">5. Drepturile Dumneavoastra</h4>
                        <p>Conform GDPR, aveti dreptul la:</p>
                        <ul>
                            <li>Accesul la datele dumneavoastra.</li>
                            <li>Rectificarea sau stergerea datelor ("dreptul de a fi uitat").</li>
                            <li>Restrictionarea prelucrarii.</li>
                        </ul>
                        <p>
                            Pentru exercitarea acestor drepturi, va rugam sa ne contactati.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Confidentialitate;
